import { Grid } from "@mui/material";
import { useEffect, useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import { LocaleContext } from "../../../../routing/LangRouter";

//import view components
import RangeSlider from "../../../common/range-slider/range-slider";

//import styles
import "./favorite-questions.scss";

function FavoriteQuestions({ favoriteQuestion, generateAnswers, userAnswers }) {
    //general variables
    const { locale } = useContext(LocaleContext);
    const { t } = useTranslation();

    //track the value of the range input
    const [rangeValue, setRangeValue] = useState(0);

    //set initial range value based on user answers
    useEffect(() => {
        if (userAnswers && userAnswers[favoriteQuestion.name] !== undefined) {
            setRangeValue(userAnswers[favoriteQuestion.name]);
        }
    }, [userAnswers]);

    //handle range value change
    const handleRangeChange = value => {
        setRangeValue(value);
    };

    //update parent component with the new answer
    useEffect(() => {
        if (rangeValue !== null) {
            generateAnswers({ name: favoriteQuestion.name, value: rangeValue });
        }
    }, [rangeValue]);

    return (
        <Grid
            className={`favorite-questions ${favoriteQuestion.active ? "active" : ""}`}
            container
            item
            xs={12}
            rowGap={2}
            justifyContent={{ xs: "flex-end", md: "space-between" }}
            alignItems="center"
        >
            <Grid container item xs={12} md={4} lg={5} xl={4} justifyContent="flex-start" alignItems="center">
                <img className="favorite-questions__img-question" src={favoriteQuestion.background} alt="" />
                <span className="favorite-questions__title">{t(favoriteQuestion.label)}</span>
            </Grid>

            <Grid className="favorite-questions__range-slider" container item xs={12} md={8} lg={7} xl={8}>
                <Grid className="favorite-questions__label-slider" item xs={12}>
                    <Grid component="span" container item xs="auto" order={locale === "en" ? 2 : 1}>
                        {t("fullyInterested")}
                    </Grid>
                    <Grid component="span" container item xs="auto" order={locale === "en" ? 1 : 2}>
                        {t("notInterested")}
                    </Grid>
                </Grid>
                <RangeSlider onChange={handleRangeChange} min={0} max={5} value={rangeValue} step={1} active={favoriteQuestion.active} />
            </Grid>
        </Grid>
    );
}

export default FavoriteQuestions;
